<template>
    <img
        alt="Slide"
        class="w-full h-full object-cover object-center rounded-md"
        width="800"
        height="500"
    />
</template>